import 'phaser'
import {
    CST
} from '../CST'

export default class EndScreenQuiz extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.ENDSCREENQUIZ)
    }

    create(data) {
        this.link = "https://www.surveymonkey.co.uk/r/Antisexism"
        this.clickSound = this.sound.add("click-sound");

        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'questionnaire-outro');

        this.add.text(470, this.cameras.main.height / 2 - 100, data.step1 + "%", CST.TEXTSTYLES.ENDSCREENQUIZ);
        this.add.text(705, this.cameras.main.height / 2 - 100, data.step2 + "%", CST.TEXTSTYLES.ENDSCREENQUIZ);
        this.add.text(950, this.cameras.main.height / 2 - 100, data.step3 + "%", CST.TEXTSTYLES.ENDSCREENQUIZ);

        this.menu_btn = this.add.image(1425, 55, 'menu-button-bubbles').setScale(.7).setDepth(1.2).setInteractive({
            useHandCursor: true
        }).on('pointerdown', () => {
            this.menu_btn.setTexture('menu-button-bubbles');
        }).on('pointerup', () => {
            this.clickSound.play();
            this.menu_btn.setTexture('menu-button');
            location.reload();
        })

        this.feedback = this.add.image(1320, 840, 'feedback-btn-2').setScale(.7).setInteractive({
            useHandCursor: true
        }).on('pointerdown', () => {
            window.open(this.link, '_blank');
        });
    }
}